module.exports = {
	"articleTitle1": "Penny W. Stamps donates $32.5 million to the School of Art & Design",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "Penny W. Stamps School Of Art & Design",
	"articleLink1": "https://www.michigandaily.com/news/art-and-design-school-be-renamed-penny-w-stamps-school-art-and-design",
	"articleLink2": "https://www.michigandaily.com/arts/10animation-b-side18",
	"articleSnippet1": "Sep 20, 2012 ... The University's Board of Regents unanimously voted Thursday to change the \nname of the School of Art & Design to the Penny W. Stamps ...",
	"articleSnippet2": "Oct 18, 2012 ... Animation's status as an art form was finally garnering legitimacy, ... The Penny W\n. Stamps School of Art & Design and LSA's Screen Arts ...",
	"totalMisc": 0,
	"articleTitle2": "How students pursue animation at the University",
	"address": "2000 Bonisteel Blvd. Ann Arbor, MI",
	"images": [],
	"position": {
		"lat": 42.289974,
		"lng": -83.717309
	},
	"tips": [],
	"bathroomrating": [],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/stamps.json
// module id = 977
// module chunks = 0